import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'

export const SelectionInfo: React.FC<{
  text: React.ReactNode
  subText?: React.ReactNode
  leftSlot?: React.ReactNode
  rightSlot?: React.ReactNode
}> = ({ text, subText, leftSlot, rightSlot }) => {
  return (
    <WrapperStyled>
      {leftSlot && <span>{leftSlot}</span>}

      <div>
        <span data-testid='SelectionHeader.Text'>{text}</span>
        {subText && <span>{subText}</span>}
      </div>

      {rightSlot && <span>{rightSlot}</span>}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx1,

  '> span': {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
  },

  '> div': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    wordBreak: 'break-word',
    hyphens: 'auto',

    '> span:nth-of-type(1)': {
      fontSize: '1.6rem',
      fontWeight: 'bold',
      lineHeight: 'normal',
    },

    '> span:nth-of-type(2)': {
      fontSize: '1.4rem',
      fontWeight: 'normal',
    },
  },
})
